(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/ball-row/assets/javascripts/ball-row-eurojackpot.js') >= 0) return;  svs.modules.push('/components/tur/ball-row/assets/javascripts/ball-row-eurojackpot.js');
'use strict';

svs.tur = svs.tur || {};
svs.tur.ball = svs.tur.ball || {};
svs.tur.ball.row = svs.tur.ball.row || {};


class RowEurojackpot extends svs.tur.ball.row.Default {
  constructor(options) {
    options.BallClass = svs.tur.ball.Eurojackpot;
    super(options);
    const numbers = options.numbers,
      balls = options.balls;
    this._numbers = numbers;
    this._balls = balls;
  }
  classNames() {
    return ['ball-row-eurojackpot'];
  }
}
svs.tur.ball.row.Eurojackpot = RowEurojackpot;

 })(window);